// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__2NEeu","unreadBadge":"styles_unreadBadge__2_c-d","modalContent":"styles_modalContent__G64vs","modal":"styles_modal__3KzJc"};